import { TrackViewContext } from '@dragonpass/intl-unified-tracker'
import { ReactNode, useMemo } from 'react'

export default function WithTrackProvider({
  children,
}: {
  children: ReactNode
}) {
  const trackViewContextValue = useMemo(
    () => ({ tracker: window.dpTracker }),
    [window.dpTracker],
  )

  return (
    <TrackViewContext.Provider value={trackViewContextValue}>
      {children}
    </TrackViewContext.Provider>
  )
}
